import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IWechatUser, defaultValue } from 'app/shared/model/wechat-user.model';

export const ACTION_TYPES = {
  FETCH_WECHATUSER_LIST: 'wechatUser/FETCH_WECHATUSER_LIST',
  FETCH_WECHATUSER: 'wechatUser/FETCH_WECHATUSER',
  CREATE_WECHATUSER: 'wechatUser/CREATE_WECHATUSER',
  UPDATE_WECHATUSER: 'wechatUser/UPDATE_WECHATUSER',
  DELETE_WECHATUSER: 'wechatUser/DELETE_WECHATUSER',
  RESET: 'wechatUser/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IWechatUser>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type WechatUserState = Readonly<typeof initialState>;

// Reducer

export default (state: WechatUserState = initialState, action): WechatUserState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_WECHATUSER_LIST):
    case REQUEST(ACTION_TYPES.FETCH_WECHATUSER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_WECHATUSER):
    case REQUEST(ACTION_TYPES.UPDATE_WECHATUSER):
    case REQUEST(ACTION_TYPES.DELETE_WECHATUSER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_WECHATUSER_LIST):
    case FAILURE(ACTION_TYPES.FETCH_WECHATUSER):
    case FAILURE(ACTION_TYPES.CREATE_WECHATUSER):
    case FAILURE(ACTION_TYPES.UPDATE_WECHATUSER):
    case FAILURE(ACTION_TYPES.DELETE_WECHATUSER):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_WECHATUSER_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_WECHATUSER):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_WECHATUSER):
    case SUCCESS(ACTION_TYPES.UPDATE_WECHATUSER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_WECHATUSER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/wechat-users';

// Actions

export const getEntities: ICrudGetAllAction<IWechatUser> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_WECHATUSER_LIST,
  payload: axios.get<IWechatUser>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity: ICrudGetAction<IWechatUser> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_WECHATUSER,
    payload: axios.get<IWechatUser>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IWechatUser> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_WECHATUSER,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IWechatUser> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_WECHATUSER,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IWechatUser> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_WECHATUSER,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
